module.exports = __webpack_public_path__ + "static/media/eye-close.7c82ae92.svg";